
// comment out for now

import axios from "axios";
import { FormText } from "react-bootstrap";
import BaseValues from "./BaseValues";

import { cancelTrip, noShowTrip } from "./BusOpsRequests";

export function checkForReassignmentChange(params) {
    console.log("CHECK FOR REASSIGNMENT CHANGE", params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/mostRecentReassignment`

    // location
    // gates
    const data = BaseValues.createFormData(params);

    const config = {
        method: "POST",
        url,
        data
    };

    return axios(config);
}

export function runReassignment(toTrip, fromTrip) {
    console.log("RUN REASSIGNMENT", toTrip, fromTrip);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/runBusReassignment`;

    /*
Day: "19"
DelayComment: ""
DelayReason: ""
Direction: "Ou"
Header: "JERSEY CITY AND BAYONNE  VIA JFK BLVD  "
HeaderCode: "2147"
LocationId: "PABT"
ManualDelay: ""
ManualLaneGate: ""
Owner: "AUTO"
Route: "119"
Run: "1"
SchedDepTime: "19-MAR-22 06:45 AM"
SchedLaneGate: "208-1"
SecLate: "0"
Time: "0645"
TimePoint: "NWYKPABT"
TripNumber: "17592844"
actual_departure_time: ""
delaycolor: "GREEN"
driver_reassigned: ""
driver_replaced: ""
has_driver: ""
passArrival: ""
passBoarding: ""
passDeparture: ""
passGetOff: ""
passLeftBehind: ""
passload: ""
radius1color: "GREY"
radius2color: "GREY"
return_trip_time: "0810A"
tripcolor: "BLUE"
vehicleIDColor: "RED"
vehicle_id: "6194"
    */

    const data = BaseValues.createFormData({
        target_internal_trip_number: toTrip.TripNumber,
        target_timing_point_id: toTrip.TimePoint,
        target_run_id: toTrip.Run,
        target_route: toTrip.Route,
        target_sched_dep_time: toTrip.SchedDepTime,
        target_vehicle_ID: toTrip.vehicle_id,
        target_scheduled_lane_gate: toTrip.SchedLaneGate,
        target_has_driver: toTrip.has_driver,
        target_driver_reassigned: toTrip.driver_reassigned,
        target_driver_replaced: toTrip.driver_replaced,

        source_internal_trip_number: fromTrip.TripNumber,
        source_timing_point_id: fromTrip.TimePoint,
        source_run_id: fromTrip.Run,
        source_route: fromTrip.Route,
        source_sched_dep_time: fromTrip.SchedDepTime,
        source_vehicle_ID: fromTrip.vehicle_id,
        source_scheduled_lane_gate: fromTrip.SchedLaneGate,
        source_has_driver: fromTrip.has_driver,
        source_driver_reassigned: fromTrip.driver_reassigned,
        source_driver_replaced: fromTrip.driver_replaced
    });
    
    const config = {
        method: "POST",
        url,
        data
    };

    return axios(config);
}

export function searchForBus(params) {
    //console.log("SEARCH FOR BUS", params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/searchForBus`

    const data = BaseValues.createFormData(params);

    // route
    // location
    const config = {
        method: "POST",
        url,
        data
    };

    return axios(config);
}

//
// these are apparently the same as the usual bus cancel/no-show...
//

export function cancelUnfilledTrip(trip, reason) {
    console.log("CANCEL UNFILLED TRIP", trip);

    // const promise = new Promise(resolve => {
    //     return {
    //         data: {
    //             success: true
    //         }
    //     };
    // });

    // return promise;

    return cancelTrip(trip, reason);
}

export function noShowUnusedBus(bus, reason) {
    console.log("No SHOW UNUSED BUS", bus, reason);

    // const promise = new Promise(resolve => {
    //     return {
    //         data: {
    //             success: true
    //         }
    //     };
    // });

    // return promise;

    return noShowTrip(bus, reason);
}